import { WebSocketMessageTypeIncoming } from '../../../Enums/WebSocketMessageTypeIncoming';
import { SettingsWebPortal } from '../../Settings/SettingsWebportal';
import { WsDeviceStatus } from './WsDeviceStatus';

export class WsDevicesStatus {
  public Type!: WebSocketMessageTypeIncoming;

  public DevicesData!: WsDeviceStatus[];

  constructor() {
    this.Type = WebSocketMessageTypeIncoming.WsDevicesStatus;
  }
}
